import { proxy } from "valtio";

export const searchQueryDebounceToken = proxy({ value: 0 });

export const createCustomGuestFormConfigurationTimestamp = (date: Date) => {
  const isoDate = date.toISOString();
  return "custom_" + isoDate.replace(/[.:-]/g, "_");
};

export const hexToRgb = (
  hex: string,
): { r: number; g: number; b: number } | null => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const getLuminance = (hexColor: string): number => {
  const rgb = hexToRgb(hexColor);
  if (!rgb) return 0;

  const sRGB = [rgb.r / 255, rgb.g / 255, rgb.b / 255];
  const adjust = (c: number) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);

  return (
    0.2126 * adjust(sRGB[0]) +
    0.7152 * adjust(sRGB[1]) +
    0.0722 * adjust(sRGB[2])
  );
};

export const getContrastRatio = (color1: string, color2: string): number => {
  const lum1 = getLuminance(color1);
  const lum2 = getLuminance(color2);
  const lighter = Math.max(lum1, lum2);
  const darker = Math.min(lum1, lum2);
  return (lighter + 0.05) / (darker + 0.05);
};
